export const createPendingRequestGate = () => {
  let pendingKey: string | null = null;

  return {
    enter(key: string) {
      if (pendingKey === key) {
        return false;
      }
      pendingKey = key;
      return true;
    },
    release() {
      pendingKey = null;
    },
  };
};
